declare var $;
export class DataTableSelect {

  public static all(event, dt){

    const prevSelectedData = (dt.componentDefinition.noClearBeforeSelectAll ) ? dt.selectedDocumentsRel : [];
    const prevSelectedDocs = (dt.componentDefinition.noClearBeforeSelectAll ) ? dt.selectedDocumentSource : [];

    const tempData = [];
    const tempDocs = [];
    dt.dtSearch.search(dt.dtSource, dt.dtData, (response) => {
      for( const row of response.data){
        tempData.push({
          documentId: row?.documentId,
          name: row?.systemHeader.summaryName
        });

        tempDocs.push(row);
      }

      dt.selectedDocumentsRel  = [...tempData, ...prevSelectedData];
      dt.selectedDocumentSource  = [...tempDocs, ...prevSelectedDocs];
      // Changing the document to update after select when not multiSelect
      dt.fieldValue = dt.selectedDocumentsRel;
      event.selectedStatus(dt);

      $(dt.table.body()).css('pointerEvents', 'auto');
      $(dt.dtWrapper.nativeElement).find('.dataTables_processing').hide();
      dt.selectAllItems = '';
      dt.valueChanged(dt.fieldValue);
    }, true);
  }

  public static docArray(event, dt){

    const tempData = [];
    let results = dt.contextParams.document[dt.componentDefinition.dataSourceName] ?? [];
    if( typeof results === 'string'){
      results  = JSON.parse(results);
    }

    for( const [i, row] of results.entries()){
      const data : {
        row: number,
        documentId?: string,
        name?: string
      } = {
        row: i
      };

      if( !Array.isArray(row)){
        data.documentId = row?.documentId ?? undefined;
        data.name = row?.systemHeader.summaryName ?? row?.name ?? undefined;
      }

      tempData.push(data);
    }

    dt.selectedDocumentsRel  = tempData;
    // Changing the document to update after select when not multiSelect
    dt.fieldValue = dt.selectedDocumentsRel;
    event.selectedStatus(dt);

    $(dt.table.body()).css('pointerEvents', 'auto');
    $(dt.dtWrapper.nativeElement).find('.dataTables_processing').hide();
    dt.selectAllItems = '';
    dt.valueChanged(dt.fieldValue);
  }

  public static multiSelect(event, dt, indexes){

    const tempData = [];
    const tempSelectedData = [];

    const selectedData = dt.table.rows( indexes ).data().toArray();
    dt.lastSelectedIndex = (indexes === undefined) ? 0 : indexes[0];

    for(const row of selectedData ){
      const selRow = dt.selectedDocumentsRel.filter((n) => n.documentId === row.documentId);
      if ( selRow.length === 0 ) {
        tempData.push({
          documentId: row?.documentId ?? undefined,
          name: row?.systemHeader.summaryName ?? undefined});

        tempSelectedData.push(row);
      }
    }

    dt.selectedDocumentsRel  = [...dt.selectedDocumentsRel, ...tempData];
    dt.selectedDocumentSource = [...dt.selectedDocumentSource, ...tempSelectedData];

    $(dt.dtWrapper.nativeElement).find('.dataTables_processing').hide();
    $(dt.table.body()).css('pointerEvents', 'auto');

  }

  public static singleSelect(event, dt, indexes){
    const selectedData = dt.table.row( indexes ).data();
    dt.lastSelectedIndex = (indexes === undefined) ? 0 : indexes[0];

    if (!dt.componentDefinition.disableAutoDisplay) {
      const documentId = ''; // = DocumentService.templates.childDoc.currentDocumentId;
      if (selectedData) {
        if (documentId !== selectedData.documentId) {
          const templateTarget = (dt.componentDefinition.templateTarget === undefined) ?
            'currentWindow' : dt.componentDefinition.templateTarget;
          if (templateTarget === 'currentWindow') {
            dt.loadChild(selectedData);
          } else {
            const closeOverlayOnSave = dt.componentDefinition.closeOverlayOnSave;

            const shouldOpenModal = !dt.isDrawing
              || (
                dt.isDrawing
                && closeOverlayOnSave !== true
                && dt.prevChildScope.selectedDocumentId === dt.lastUpdatedDoc.documentId
                && dt.isFromDocumentUpdate
              )

            const childScope = dt.initChildDoc(selectedData.documentId);
            dt.prevChildScope = childScope;

            if(shouldOpenModal){
              const url = 'form/' + selectedData.documentId;
              dt.sclUtilUrlService.openLink(url, templateTarget, childScope);
            }
          }
        }
      }

    }

    dt.selectedDocumentsRel = [{
      documentId: selectedData.documentId ?? '',
      name: selectedData.systemHeader?.summaryName ?? ''
    }];
  }

  public static singleSelectArray(event, dt, indexes){
    const pageInfo = dt.table.page.info();
    const index = indexes[0] ?? 0;

    const selectRowIndex = (pageInfo.page * pageInfo.length) + index;
    const selectedData = dt.table.row( indexes ).data();

    // dt.lastSelectedIndex = (indexes === undefined) ? 0 : indexes[0];

    dt.selectedDocumentsRel = [{
      row: selectRowIndex,
      documentId: selectedData.documentId ?? undefined,
      name: selectedData.systemHeader?.summaryName ?? selectedData?.name ?? undefined
    }];

  }

  public static multiSelectArray(event, dt, indexes){
    const pageInfo = dt.table.page.info();
    const index = indexes[0] ?? 0;

    const selectRowIndex = (pageInfo.page * pageInfo.length) + index;
    const selectedData = dt.table.rows( indexes ).data().toArray();
    const tempData = [];

    for(const row of selectedData ){
      const selRow = dt.selectedDocumentsRel.filter((n) => n.row === selectRowIndex);
      if ( selRow.length === 0 ) {
         tempData.push({
          row: selectRowIndex,
          documentId: row.documentId ?? undefined,
          name: row.systemHeader?.summaryName ?? row?.name ?? undefined
        });
      }
    }


    dt.selectedDocumentsRel  = [...dt.selectedDocumentsRel, ...tempData];
    $(dt.dtWrapper.nativeElement).find('.dataTables_processing').hide();
    $(dt.table.body()).css('pointerEvents', 'auto');

  }

  public static deselect(event, dt, indexes){
    const selectedData = dt.table.rows( indexes ).data().toArray();

    // dt.selectedDocumentsRel = dt.selectedDocumentsRel.filter((n) => n.documentId !== selectedData.documentId );
    let tempData = dt.selectedDocumentsRel;
    let tempSelectedData = dt.selectedDocumentSource;
    for(const row of selectedData){
      tempData = tempData.filter((n) => n.documentId !== row.documentId );
      tempSelectedData = tempSelectedData.filter((n) => n.documentId !== row.documentId );
    }

    dt.selectedDocumentsRel = tempData;
    dt.selectedDocumentSource = tempSelectedData;
  }

  public static deselectArray(event, dt, indexes){
    const pageInfo = dt.table.page.info();
    const index = indexes[0] ?? 0;

    const selectRowIndex = (pageInfo.page * pageInfo.length) + index;
    const selectedData = dt.table.rows( indexes ).data().toArray();

    // dt.selectedDocumentsRel = dt.selectedDocumentsRel.filter((n) => n.documentId !== selectedData.documentId );
    let tempData = dt.selectedDocumentsRel;
    for(const row of selectedData){
      tempData = tempData.filter((n) => n.row !== selectRowIndex );
    }

    dt.selectedDocumentsRel = tempData;
  }
}
